import { createFileRoute } from "@tanstack/react-router"
import CreateOrUpdatePurchaseOrder from "~/components/purchaseOrder/CreateOrUpdatePurchaseOrder"
import LoadingOverlay from "~/components/reusable/LoadingOverlay"
import { usePageTracking } from "~/hooks/usePageTracking"
import { useGetPurchaseOrder } from "~/hooks/usePurchaseOrders"
import { useRecordRecentlyViewed } from "~/hooks/useRecentlyViewed"

export const Route = createFileRoute("/_auth/procurement/purchase-orders/update/$purchaseOrderId")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Purchase Order")
  const { purchaseOrderId } = Route.useParams()

  const { data: purchaseOrder, isLoading } = useGetPurchaseOrder(
    purchaseOrderId ? Number(purchaseOrderId) : undefined,
  )

  useRecordRecentlyViewed(
    purchaseOrder
      ? {
          type: "purchase-order",
          route: `/procurement/purchase-orders/update/${purchaseOrderId}`,
          label: purchaseOrder.name,
        }
      : null,
  )

  if (isLoading) return <LoadingOverlay />

  return <CreateOrUpdatePurchaseOrder purchaseOrder={purchaseOrder ?? undefined} />
}
